import { STATUS } from "../../../constants/constants";

export const VALIDATION_OBJ = {

    enblAlrtsAndVldtinsFlag: {},

    // Primary Details
    title: {
        shouldValidate: true,
        validation: {
            required: {
                value: true,
                message: 'Please enter Title'
            },
            maxLength: {
                value: 850,
                message: 'Please enter value less than or equal to 850 characters'
            }
        },
        tab: 'primaryDetails'
    },
    originalTitle: {},
    authors: {
        shouldValidate: true,
        validation: {
            required: {
                value: true,
                message: 'Please Enter Authors'
            }
        },
        tab: 'primaryDetails'
    },
    receivedFrom: {
        shouldValidate: true,
        validation: {
            required: {
                value: true,
                message: 'Please Enter Received From'
            },
            maxLength: {
                value: 850,
                message: 'Please enter value less than or equal to 850 characters'
            }
        },
        tab: 'primaryDetails'
    },
    source: {
        shouldValidate: true,
        validation: {
            required: {
                value: true,
                message: 'Please Enter Source'
            },
        },
        tab: 'primaryDetails'
    },

    productId: {
    },
    institution: {},
    caseIds: {
        shouldValidate: false,
        validation: {
            required: {
                value: true,
                message: 'Please enter Case IDs '
            },
            maxLength: {
                value: 8000,
                message: 'Please enter value less than or equal to 8000 characters'
            }
        },
        tab: 'primaryDetails'
    },
    countryId: {},
    documentSiteOrigin: {},
    abstract: {},
    notes: {},
    keywords: {},

    // Secondary Details

    urlToOvid: {
        shouldValidate: true,
        valid: true,
        validation: {
            maxLength: {
                value: 6000,
                message: 'Please enter value less than or equal to 6000 characters'
            }
        },
        tab: 'secondaryDetails'
    },
    explanationId: {
        shouldValidate: true,
        validation: {
            required: {
                value: true,
                message: 'Please Select Explanation'
            }
        },
        tab: 'secondaryDetails'
    },
    urlToSourceDb: {

    },
    statusId: {
        shouldValidate: true,
        validation: {
            required: {
                value: true,
                message: 'Please Select Status'
            }
        },
        tab: 'secondaryDetails'
    },
    otherStatus: {
        shouldValidate: false,
        validation: {
            required: {
                value: false,
                message: 'Please enter Other Status'
            },
            maxLength: {
                value: 200,
                message: 'Please enter value less than or equal to 200 characters'
            }
        },
        tab: 'secondaryDetails'
    },
    lockByDate: {
        shouldValidate: false,
        validation: {
            required: {
                value: false,
                message: 'Please Select Lock By date'
            }
        },
        tab: 'secondaryDetails'
    },
    originalAbstractId: {
        shouldValidate: false,
        validation: {
            required: {
                value: true,
                message: 'Please Select Original Abstract'
            }
        },

        tab: 'secondaryDetails'
    },
    siteProcessingDocument: {},
    abstractLanguage: {},
    caseManagerId1: {
        shouldValidate: false,
        validation: {
            required: {
                value: true,
                message: 'Please Select Abstract Record Screener'
            }
        },
        tab: 'secondaryDetails'
    },
    caseManagerId2: {},
    caseManagerId3: {},
    fileAttachment: {},

    // Date Details

    dateRecordReceived: {
        shouldValidate: true,
        validation: {
            required: {
                value: true,
                message: 'Please Enter Date Record Received'
            }
        },
        defaultValidate: true,
        tab: 'dateDetails',
        type: 'attribute'
    },
    dateTranslationRequested: { type: 'attribute' },
    dateArticleOrdered: { type: 'attribute' },
    dateTranslationReceived: { type: 'attribute' },
    dateArticleOrdered2: { type: 'attribute' },
    dateAbstractValid: {
        shouldValidate: false,
        validation: {
            required: {
                value: true,
                message: 'Please Enter Date Abstract Valid'
            }
        },
        type: 'attribute',
        tab: 'dateDetails'
    },
    dateArticleReceived: { type: 'attribute' },
    dateArticleValid: {
        shouldValidate: false,
        validation: {
            required: {
                value: true,
                message: 'Please Enter Date Article Valid'
            }
        },
        tab: 'dateDetails',
        type: 'attribute'
    },
    dateAbstractReviewed: { type: 'attribute' },
    dateFlwUpReceived: { type: 'attribute' },
    dateArticleReviewed: { type: 'attribute' },
    dateClosed: {
        shouldValidate: false,
        validation: {
            required: {
                value: true,
                message: 'Please Enter Date Closed'
            },
            notRequired: {
                value: false,
                message: 'Date Closed should be blank'
            }
        },
        tab: 'dateDetails',
        type: 'attribute'
    },
    dateTranslationValid: { type: 'attribute' },

    resetFormValidation: function () {
        Object.keys(this).forEach(key => {
            delete this[key]['valid'];
            delete this[key]['error'];
        });
        this.urlToOvid = true;
    },
    resetConditionalValidation: function () {
        this.originalAbstractId.shouldValidate = false;
        this.dateClosed.shouldValidate = false;
        this.dateClosed.validation.required.value = true;
        this.dateClosed.validation.notRequired.value = false;
        this.caseManagerId1.shouldValidate = false;
        this.dateAbstractValid.shouldValidate = false;
        this.dateArticleValid.shouldValidate = false;
        this.caseIds.shouldValidate = false;
        this.otherStatus.shouldValidate = false;
        this.otherStatus.validation.required.value = false;
    },
    clearError: function () {
        ['originalAbstractId', 'dateClosed', 'caseManagerId1', 'dateAbstractValid', 'dateArticleValid', 'caseIds', 'otherStatus'].forEach(identifier => {
            delete this[identifier].valid;
            delete this[identifier].error;
        })
    },
    init: function (formData) {
        this.resetConditionalValidation();
        this.clearError();

        const clonedFormData = { ...formData }
        const formDropDownFields = ['productId', 'countryId', 'explanationId', 'statusId', 'siteProcessingDocument']
        formDropDownFields.forEach(el => {
            clonedFormData[el] = clonedFormData[el] ? clonedFormData[el].value : null;
        })

        const { statusId,
            originalAbstractId,
            caseIds,
            caseManagerId1,
            dateClosed,
            dateAbstractValid,
            dateArticleReceived,
            dateArticleValid,
            explanationId,
            lockByDate,
            otherStatus
        } = { ...clonedFormData }

        if ([STATUS.LINKED].includes(statusId)) {
            this.originalAbstractId.shouldValidate = true;
            this.applyValidation('originalAbstractId', originalAbstractId);
        }

        if ([STATUS.NOT_ORDERED,
        STATUS.VALID_NON_ENTRY,
        STATUS.VALID,
        STATUS.NON_VALID,
        STATUS.ARTICLE_NOT_RETRIEVABLE,
        STATUS.JP_RESEARCH,
        STATUS.NO_JP_RESEARCH].includes(statusId)) {
            this.dateClosed.shouldValidate = true;
            this.applyValidation('dateClosed', dateClosed)
        }

        if ([
            STATUS.REVIEW_NEEDED,
            STATUS.OTHER,
            STATUS.ORDER_VALID,
            STATUS.JP_DEVICE_ORDER_VALID,
            STATUS.ARTICLE_ORDERED_VALID,
            STATUS.ARTICLE_ORDERED_JP_RESEARCH,
            STATUS.ORDER_NON_VALID,
            STATUS.JP_DEVICE_ORDER_NON_VALID,
            STATUS.ARTICLE_ORDERED_NON_VALID,
            STATUS.JP_RESEARCH_ORDER,
            STATUS.NEW,
            STATUS.TRANSLATION_REQUESTED,
            STATUS.QUALITY_REVIEW
        ].includes(statusId)) {
            this.dateClosed.shouldValidate = true;
            this.dateClosed.validation.required.value = false;
            this.dateClosed.validation.notRequired.value = true;
            this.applyValidation('dateClosed', dateClosed);
        }

        if ([STATUS.NON_VALID, STATUS.NOT_ORDERED, STATUS.DUPLICATE].includes(statusId)) {
            this.explanationId.shouldValidate = true;
            this.explanationId.validation.required.value = true;
            this.applyValidation('explanationId', explanationId);
        }

        if (![STATUS.NON_VALID, STATUS.NOT_ORDERED, STATUS.DUPLICATE].includes(statusId)) {
            this.explanationId.shouldValidate = false;
            this.explanationId.validation.required.value = false;
            this.applyValidation('explanationId', explanationId);
        }

        if (statusId === STATUS.OTHER) {
            this.otherStatus.shouldValidate = true;
            this.otherStatus.validation.required.value = true;
            this.applyValidation('otherStatus', otherStatus);

            this.lockByDate.shouldValidate = true;
            this.lockByDate.validation.required.value = true;
            this.applyValidation('lockByDate', lockByDate);

        }
        if (!otherStatus || otherStatus === "" || statusId !== STATUS.OTHER) {
            this.lockByDate.shouldValidate = false;
            this.lockByDate.validation.required.value = false;
            this.applyValidation('lockByDate', lockByDate);
        }

        if ([STATUS.NOT_ORDERED,
        STATUS.VALID_NON_ENTRY,
        STATUS.VALID,
        STATUS.NON_VALID,
        STATUS.LINKED].includes(statusId) && dateClosed) {
            this.caseManagerId1.shouldValidate = true;
            this.applyValidation('caseManagerId1', caseManagerId1);
        }
        if ([STATUS.ORDER_VALID, STATUS.JP_DEVICE_ORDER_VALID].includes(statusId)) {
            this.dateAbstractValid.shouldValidate = true;
            this.applyValidation('dateAbstractValid', dateAbstractValid);
        }
        if ([STATUS.VALID].includes(statusId)) {
            this.caseIds.shouldValidate = true;
            this.applyValidation('caseIds', caseIds);
        }
        if ([STATUS.VALID, STATUS.VALID_NON_ENTRY].includes(statusId) && dateArticleReceived) {
            this.dateArticleValid.shouldValidate = true;
            this.applyValidation('dateArticleValid', dateArticleValid);
        }
    },
    applyValidation: function (identifier, value) {
        let validityResult = checkFieldValidity(value, this[identifier].validation);
        this[identifier].valid = validityResult.valid;
        this[identifier].error = validityResult.error;
    },
    checkFormValidity: function async() {
        // Check Primary, Secondary, Date Details are valid or not .
        let fvalid = true, pdValid = true, sdValid = true, ddValid = true;

        Object.values(this).forEach(obj => {
            if (obj.tab === 'primaryDetails' && obj.shouldValidate) {
                pdValid = obj.valid && pdValid;
            }
            if (obj.tab === 'secondaryDetails' && obj.shouldValidate) {
                sdValid = obj.valid && sdValid;
            }
            if (obj.tab === 'dateDetails' && obj.shouldValidate) {
                ddValid = obj.valid && ddValid;
            }
        })
        fvalid = pdValid && sdValid && ddValid;
        return {
            isFormValid: fvalid,
            isPrimaryDetailsValid: pdValid,
            isSecondaryDetailsValid: sdValid,
            isDateDetailsValid: ddValid,
        }
    },
    setFormValidity: function (editFormData) {
        Object.entries(editFormData).forEach(data => {
            const [key, value] = data;
            if (this[key] && (this[key].hasOwnProperty('shouldValidate') && this[key].shouldValidate)) {
                this.applyValidation(key, value);
            }
        })
        this.init(editFormData);
        let result = this.checkFormValidity();
        return result;
    },

    validateFiles: function (filesArr) {
        const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB 
        const ALLOWED_FILE_EXTENSION = ['pdf', 'ps', 'mw', 'xls', 'xlsx', 'ppt', 'pptx', 'doc', 'docx', 'wks',
            'wps', 'wdb', 'wri', 'rtf', 'ans', 'txt', 'html', 'phtml', 'shtml', 'stm', 'dhtml', 'jsp', 'xml', 'sgml'];

        let invalidFileSizeArr = filesArr.filter(file => file.size > MAX_FILE_SIZE);
        let invalidFileExtArr = filesArr.filter(file => {
            let filename = file.name;
            let indexStart = filename.lastIndexOf('.') + 1;
            let indexEnd = filename.length;
            let fileExt = filename.substring(indexStart, indexEnd).toLowerCase();
            return !ALLOWED_FILE_EXTENSION.includes(fileExt);
        })

        let totalInvalidFiles = invalidFileSizeArr.concat(invalidFileExtArr);
        let totalInvalidFileNames = [...new Set(totalInvalidFiles.map(f => f.name))];

        let errObj = {
            invalidFileSizeArr,
            invalidFileExtArr,
            totalInvalidFileNames
        }
        return errObj;
    }
}

export const checkFieldValidity = (value, rules) => {
    let valid = true;
    let error = null;
    value = typeof value === 'string' ? value.trim() : value;
    if (rules.required && rules.required.value) {
        valid = value && valid;
        error = !valid ? rules.required.message : error;
    }

    if (rules.notRequired && rules.notRequired.value) {
        valid = !value && valid;
        error = !valid && !error ? rules.notRequired.message : error;
    }

    if (rules.minLength) {
        valid = value.length >= rules.minLength.value && valid
        error = !valid && !error ? rules.minLength.message : error;
    }

    if (rules.maxLength && value) {
        valid = value.length <= rules.maxLength.value && valid
        error = !valid && !error ? rules.maxLength.message : error;
    }

    let data = { valid, error };
    return data;
}